import styled, { css } from 'styled-components';
import { Blue, Gray } from '../../colors';
import { SCREEN_SIZE } from '../index';
export const Container = styled.div `
    width: ${props => props.width ? `${props.width}px` : '100%'};
    padding: 20px;
    box-sizing: border-box;

    @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
        padding: 0px;
        position: absolute;
        left: 0;
        bottom: -1px;
    }
`;
export const Label = styled.span `
    display: inline-block;
    padding-bottom: 12px;
    font-size: 14px;
`;
export const Bar = styled.div `
    font-family: Gilroy;
    font-weight: bold;
    color: ${Blue[2]};
    position: relative;

    ${props => props.disabled && css `
        & > ${Label} {
            color: ${Gray.normal};
        }
    `}
    
    &::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 4px;
        background: ${Gray.normal};
        border-radius: 2px;
        left: 0;
        bottom: 1px;

        @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
            height: 2px;
            border-radius: 0px;
        }
    }

    &::after {
        content: '';
        position: absolute;
        width: ${props => props.progress ? `${props.progress}%` : '6px'};
        height: 6px;
        background: ${Blue[2]};
        border-radius: ${props => props.progress === 0 ? '50%' : '4px'} ;
        left: 0;
        bottom: 0;
        visibility: ${props => props.disabled ? 'hidden' : 'visible'};

        @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
            height: 3px;
            border-radius: 0px;
            width: ${props => props.progress ? props.progress : '0'}%;
        }
    }
`;
//# sourceMappingURL=ProgressBar.styled.js.map